export const StandardFont = {
    family: '"Source Sans Pro", "Helvetica Neue", sans-serif',
    size: 16,
    weight: 600,        // semi-bold
    color: '#1e1e1e',   // dark-grey
} as const;
